import React from 'react'
import { useTranslation } from 'react-i18next'
import { TelegramAccountEntity } from '../../../domain/entities/TelegramAccount'
import TelegramAccountCard from '../TelegramAccountCard/TelegramAccountCard.component'
import { GridList } from '../GridList'
import EmptyState from '../EmptyState/EmptyState.component'
import './TelegramAccountsList.styles.css'

type TelegramAccountsListProps = { accounts?: TelegramAccountEntity[]; isLoading: boolean; onAccountUpdated?: () => Promise<void>; searchQuery?: string }

const TelegramAccountsList: React.FC<TelegramAccountsListProps> = ({ accounts = [], isLoading, onAccountUpdated, searchQuery = '' }) => {
  const { t } = useTranslation()

  const emptyTitle = searchQuery 
    ? t('accounts-not-found', { ns: 'standard' }) 
    : t('no-telegram-accounts', { ns: 'standard' })
  
  const emptyDescription = searchQuery 
    ? t('accounts-not-found-by-query', { ns: 'standard', query: searchQuery })
    : t('no-telegram-accounts-description', { ns: 'standard' })

  return (
    <div className="telegram-accounts-list-container">
      <GridList
        dataSource={accounts}
        loading={isLoading}
        renderItem={(wrappedItem) => (
          <TelegramAccountCard
            telegramAccount={wrappedItem.originalItem}
            onAccountUpdated={onAccountUpdated || (() => Promise.resolve())}
          />
        )}
        emptyComponent={
          <EmptyState
            icon="📱"
            title={emptyTitle}
            description={emptyDescription}
          />
        }
      />
    </div>
  )
}

export default TelegramAccountsList
